<template>
  <div id="app" class="min-h-screen flex flex-col bg-gray-100">
    <div class="flex-grow">
      <router-view />
    </div>
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  components: {
    FooterSection
  }
});
</script>
